export default __webpack_public_path__ + "static/media/block-align-top.87be8137.svg";